import api from "@/config/axiosConfig";

interface RemoveTripParticipantParams {
  tripId: string;
  userId: string;
  removerId: string;
}

export async function removeTripParticipant({
  tripId,
  userId,
  removerId,
}: RemoveTripParticipantParams): Promise<any> {
  try {
    const response = await api.social.delete(
      `/trips/${tripId}/participants/${userId}`,
      {
        data: {
          removerId,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error removing participant from trip:", error);
    throw error;
  }
}
